<div *ngIf="loading" class="k-i-loading"></div>
<div class="home-contenedor-maquinas home-maquinas-cont" [ngClass]="{'cargando':  loading, 'cargado': !loading}">
  <!-- MAQUINAS -->
  <ng-container *ngFor="let maquina of datosMaquinas">
      <div class="home-contenedor-maq" *ngIf="appComponent.selectedGrupo.idMaquinas.includes(maquina.id) && maquina?.home != undefined">
          
        <div class="home-contenedor-maq-inner" [ngClass]="{'ejecucion': maquina.home.idEstado == 1
                                                          , 'parada': maquina.home.idEstado == 2
                                                          , 'preparacion': maquina.home.idEstado == 3
                                                          , 'mantenimiento': maquina.home.idEstado == 4
                                                          , 'alarma': maquina.home.idEstado == 6
                                                          , 'apagada': maquina.home.idEstado == 8}">

            <div class="estado"></div>

            <!-- INFORMACION DE LA MAQUINA -->
            <div class="home-informacion-maquina" (click)="redirigirAProceso(maquina.id, maquina.tipo_maquina, maquina.puestoOffline)">

              <!-- Imagen de la maquina -->
              <div class="home-imagen-maquina">
                  <img src="{{maquina.imagenBase64}}" />
              </div>

              <!-- Nombre de la maquina y operario y alarma/mantenimiento -->
              <div class="home-nombre-operario-maquina">
                <div class="home-nombre-maquina">
                  <label title="{{maquina.nombre}}">{{maquina.nombre}}</label>
                </div>
                <div class="home-operario-maquina operario-multiple" *ngIf="maquina.home.datosOperarios.length > 1" >
                  <div  class="un-operario-multiple" *ngFor="let operario of maquina.home.datosOperarios">
                    <span title="{{operario.operario}}" *ngIf="operario.operarioSiglas!=''" class="grid-circulo">{{operario.operarioSiglas}}</span>
                    <i *ngIf="operario.operarioSiglas==''" class="icon-usuario"></i>
                  </div>
                </div>
                <div class="home-operario-maquina" *ngIf="maquina.home.datosOperarios.length == 1">
                  <span *ngIf="maquina.home.datosOperarios[0].operarioSiglas!=''" title="{{maquina.home.datosOperarios[0].operario}}" class="grid-circulo">{{maquina.home.datosOperarios[0].operarioSiglas}}</span>
                  <i *ngIf="maquina.home.datosOperarios[0].operarioSiglas==''" title="{{maquina.home.datosOperarios[0].operario}}" class="icon-usuario"></i>
                  <label title="{{maquina.home.datosOperarios[0].operario}}">{{maquina.home.datosOperarios[0].operario}}</label>
                </div>

                <!-- Mantenimiento -->
                <div *ngIf="maquina.home.idEstado == 4" class="aviso-mantenimiento aviso-mant-alarm">
                  <div class="icono-aviso">

                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1187_3943)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7593 9.71017C15.7631 9.6844 15.7652 9.65801 15.7652 9.63113C15.7652 9.33971 15.5289 9.10352 15.2375 9.10352C14.9852 9.10352 14.7742 9.28071 14.7222 9.51747L14.7201 9.51712L14.7198 9.51928C14.4631 10.8983 13.776 12.1604 12.7573 13.1246C11.7381 14.0894 10.4393 14.7062 9.04747 14.8865C7.65571 15.0668 6.2426 14.8012 5.0112 14.128C3.94291 13.544 3.05909 12.6791 2.45228 11.6318H4.7071C4.98029 11.6318 5.20175 11.4103 5.20175 11.1371C5.20175 10.8639 4.98029 10.6424 4.7071 10.6424H1.24448C0.910574 10.6424 0.639893 10.9131 0.639893 11.247V14.2699C0.639893 14.5431 0.861359 14.7646 1.13455 14.7646C1.40775 14.7646 1.62921 14.5431 1.62921 14.2699V12.317C1.67759 12.3961 1.72737 12.4744 1.77849 12.5516C2.46657 13.5911 3.40029 14.4528 4.50377 15.0561C5.93143 15.8366 7.56977 16.1445 9.1834 15.9355C10.797 15.7265 12.3028 15.0114 13.4845 13.8929C14.3978 13.0283 15.0812 11.9573 15.4818 10.7767C15.5993 10.4301 15.6925 10.0741 15.76 9.71114L15.7601 9.71038L15.7593 9.71017Z" fill="#99AFC6"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7847 6.94047C2.08006 5.56582 2.80442 4.32018 3.85322 3.38372C4.90209 2.44719 6.22131 1.868 7.62062 1.72966C9.01996 1.59132 10.427 1.90099 11.639 2.614C12.6743 3.2231 13.5215 4.09966 14.0948 5.14663H12.0173C11.7441 5.14663 11.5226 5.36809 11.5226 5.64128C11.5226 5.91448 11.7441 6.13595 12.0173 6.13595H15.37C15.7039 6.13595 15.9746 5.86526 15.9746 5.53136V2.28859C15.9746 2.0154 15.7531 1.79393 15.4799 1.79393C15.2067 1.79393 14.9852 2.0154 14.9852 2.28859V4.57109C14.9338 4.47926 14.8804 4.3886 14.8253 4.29914C14.17 3.23504 13.262 2.34159 12.1754 1.70228C10.7702 0.875621 9.13886 0.516598 7.51655 0.676986C5.89422 0.837373 4.36474 1.50888 3.14869 2.59468C2.20824 3.43439 1.49284 4.48833 1.05851 5.66016C0.941109 5.9769 0.844247 6.30225 0.769025 6.63431C0.764771 6.64991 0.761215 6.6658 0.758393 6.68195C0.75573 6.69406 0.753095 6.70618 0.750488 6.71831L0.753272 6.71891C0.751432 6.73684 0.750488 6.75503 0.750488 6.77344C0.750488 7.06485 0.98672 7.30108 1.27813 7.30108C1.5116 7.30108 1.70965 7.14944 1.77917 6.93929L1.7847 6.94047Z" fill="#99AFC6"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_1187_3943">
                      <rect width="16" height="16" fill="white"/>
                      </clipPath>
                      </defs>
                      </svg>
                  </div>
                    
                  <label title="{{maquina.home.maquinaMantenimiento}}"> {{maquina.home.maquinaMantenimiento}}</label>
                </div>
                <!-- Alarma -->
                <div *ngIf="maquina.home.idEstado == 6" class="aviso-alarma aviso-mant-alarm">
                  <div class="icono-aviso">
                    <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="path-1-inside-1_0_1" fill="white">
                        <path d="M0.701578 16C0.565629 16 0.445993 15.9681 0.342672 15.9042C0.239335 15.8403 0.158963 15.7561 0.101557 15.6516C0.0404324 15.5552 0.00681856 15.4468 0.000715601 15.3262C-0.00540325 15.2057 0.027718 15.0848 0.100079 14.9636L8.58433 0.336569C8.65552 0.223442 8.74124 0.139065 8.84149 0.0834389C8.94175 0.027813 9.05239 0 9.17341 0C9.29444 0 9.40508 0.027813 9.50533 0.0834389C9.60559 0.139065 9.69131 0.223442 9.76249 0.336569L18.2467 14.9636C18.3191 15.0848 18.3522 15.2057 18.3461 15.3262C18.34 15.4468 18.3064 15.5552 18.2453 15.6516C18.1879 15.7561 18.1075 15.8403 18.0042 15.9042C17.9008 15.9681 17.7812 16 17.6452 16H0.701578Z"/>
                      </mask>
                      <path d="M0.342672 15.9042L1.13158 14.6284L1.13135 14.6282L0.342672 15.9042ZM0.101557 15.6516L1.41633 14.9295L1.3935 14.8879L1.36809 14.8479L0.101557 15.6516ZM0.000715601 15.3262L1.4988 15.2504L1.49879 15.2502L0.000715601 15.3262ZM0.100079 14.9636L1.38804 15.7325L1.39287 15.7244L1.3976 15.7162L0.100079 14.9636ZM8.58433 0.336569L7.31477 -0.462306L7.30037 -0.439428L7.28681 -0.416047L8.58433 0.336569ZM9.76249 0.336569L11.06 -0.416047L11.0465 -0.439428L11.0321 -0.462306L9.76249 0.336569ZM18.2467 14.9636L16.9492 15.7162L16.954 15.7244L16.9588 15.7325L18.2467 14.9636ZM18.3461 15.3262L19.8442 15.4023L19.8442 15.4021L18.3461 15.3262ZM18.2453 15.6516L16.9787 14.8479L16.9533 14.8879L16.9305 14.9295L18.2453 15.6516ZM18.0042 15.9042L17.2155 14.6282L17.2153 14.6284L18.0042 15.9042ZM0.701578 14.5C0.810174 14.5 0.97041 14.5287 1.13158 14.6284L-0.446232 17.18C-0.0784238 17.4074 0.321083 17.5 0.701578 17.5V14.5ZM1.13135 14.6282C1.24393 14.6978 1.34669 14.8027 1.41633 14.9295L-1.21322 16.3736C-1.02877 16.7095 -0.765257 16.9828 -0.446002 17.1801L1.13135 14.6282ZM1.36809 14.8479C1.45377 14.9829 1.4926 15.128 1.4988 15.2504L-1.49737 15.4021C-1.47896 15.7656 -1.3729 16.1276 -1.16497 16.4552L1.36809 14.8479ZM1.49879 15.2502C1.51012 15.4734 1.44133 15.6432 1.38804 15.7325L-1.18789 14.1947C-1.3859 14.5264 -1.52092 14.938 -1.49736 15.4023L1.49879 15.2502ZM1.3976 15.7162L9.88186 1.08918L7.28681 -0.416047L-1.19745 14.211L1.3976 15.7162ZM9.8539 1.13544C9.81298 1.20048 9.72402 1.3092 9.56925 1.39507L8.11374 -1.22819C7.75846 -1.03107 7.49806 -0.753596 7.31477 -0.462306L9.8539 1.13544ZM9.56925 1.39507C9.43437 1.46991 9.29237 1.5 9.17341 1.5V-1.5C8.8124 -1.5 8.44913 -1.41428 8.11374 -1.22819L9.56925 1.39507ZM9.17341 1.5C9.05445 1.5 8.91246 1.46991 8.77757 1.39507L10.2331 -1.22819C9.8977 -1.41428 9.53442 -1.5 9.17341 -1.5V1.5ZM8.77757 1.39507C8.62281 1.3092 8.53385 1.20048 8.49292 1.13544L11.0321 -0.462306C10.8488 -0.753596 10.5884 -1.03107 10.2331 -1.22819L8.77757 1.39507ZM8.46497 1.08918L16.9492 15.7162L19.5443 14.211L11.06 -0.416047L8.46497 1.08918ZM16.9588 15.7325C16.9055 15.6432 16.8368 15.4735 16.8481 15.2504L19.8442 15.4021C19.8677 14.9379 19.7327 14.5264 19.5347 14.1947L16.9588 15.7325ZM16.8481 15.2502C16.8543 15.1278 16.8931 14.9828 16.9787 14.8479L19.5118 16.4552C19.7197 16.1276 19.8258 15.7658 19.8442 15.4023L16.8481 15.2502ZM16.9305 14.9295C17.0001 14.8027 17.1029 14.6978 17.2155 14.6282L18.7928 17.1801C19.1121 16.9828 19.3756 16.7095 19.56 16.3736L16.9305 14.9295ZM17.2153 14.6284C17.3764 14.5287 17.5367 14.5 17.6452 14.5V17.5C18.0257 17.5 18.4252 17.4074 18.7931 17.18L17.2153 14.6284ZM17.6452 14.5H0.701578V17.5H17.6452V14.5Z" fill="#F44336" mask="url(#path-1-inside-1_0_1)"/>
                      <path d="M9.66874 13.3142C9.55659 13.4293 9.41546 13.4868 9.24535 13.4868C9.07526 13.4868 8.93268 13.4307 8.81762 13.3185C8.70255 13.2064 8.64502 13.0652 8.64502 12.8951C8.64502 12.725 8.70111 12.5825 8.81328 12.4674C8.92545 12.3524 9.06658 12.2948 9.23667 12.2948C9.40676 12.2948 9.54934 12.3509 9.6644 12.4631C9.77947 12.5752 9.837 12.7164 9.837 12.8865C9.837 13.0565 9.78092 13.1991 9.66874 13.3142Z" fill="#F44336"/>
                      <path d="M9.62977 10.9968C9.5283 11.1005 9.40028 11.1524 9.24568 11.1524C9.09109 11.1524 8.9615 11.1005 8.85691 10.9968C8.75233 10.8931 8.70004 10.7647 8.70004 10.6114V6.49995C8.70004 6.34668 8.75078 6.2182 8.85226 6.11451C8.95372 6.01083 9.08175 5.95898 9.23634 5.95898C9.39095 5.95898 9.52054 6.01083 9.62512 6.11451C9.72969 6.2182 9.78198 6.34668 9.78198 6.49995V10.6114C9.78198 10.7647 9.73124 10.8931 9.62977 10.9968Z" fill="#F44336"/>
                    </svg>
                  </div>

                  <label title="{{maquina.home.alarma}}"> {{maquina.home.alarma}}</label>
                </div>
                <!-- Calidad -->
                <div class="calidad-home" *ngIf="maquina.home.datosOperaciones.length > 0 && maquina.home.datosOperaciones[0]?.calidad?.length > 0">
                  <label title="{{'proxCalidad' | translate}}"> {{'proxCalidad' | translate}}:</label>
                  <label title="{{myFunctions.secondsTo_HH_MM_SS(maquina.home.datosOperaciones[0]?.tiempoCalidadRestante)}}"> {{myFunctions.secondsTo_HH_MM_SS(maquina.home.datosOperaciones[0]?.tiempoCalidadRestante)}}</label>
                </div>
              </div>

              <!-- Tiempo de ejecucion -->
              <div class="home-tiempo-maquina-contenedor">
                  <div class="home-tiempo-estado-maquina">
                  <kendo-label text="{{ timeDiff(maquina.home.tiempoEstado, maquina.home.now) }}"></kendo-label>
                  </div>
                  <div class="home-estado-maquina">
                  <kendo-label text="{{ maquina.home.estado }}"></kendo-label>
                  </div>
              </div>

            </div>

            <!-- TODAS LAS OPERACIONES DE LA MAQUINA -->
            <div id="{{'carouselExampleIndicators_'+ maquina.id}}" class="carousel slide" data-ride="false" *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion"
                  >
              <ol class="carousel-indicators" *ngIf="maquina.home.datosOperaciones.length>1">
                <li [attr.data-target]="'#carouselExampleIndicators_' + maquina.id" [attr.data-slide-to]="i" [ngClass]="i == 0 ? 'active': ''" *ngFor="let datoOperacion of maquina.home.datosOperaciones; let i = index"></li>
              </ol>

              <div class="carousel-inner" (click)="redirigirAProceso(maquina.id, maquina.tipo_maquina, maquina.puestoOffline)">
                <div class="carousel-item" [ngClass]="i == 0 ? 'active': ''" *ngFor="let datoOperacion of maquina.home.datosOperaciones; let i = index">
                  <!--[ngClass]="i == 0 ? 'active': ''"-->
                  <div class="home-operaciones-contenedor">
                    <div class="{{'home-operacion-maquina_'+maquina.id}}">
                      <!-- INFORMACION DE LA OPERACION-->
                      <div class="home-operacion-contenedor">

                        <!-- COL 1 SI NO TIENE GRUPOS -->
                        <div class="home-informacion-operacion" [ngClass]="(datoOperacion?.colada!=''
                                                                              || datoOperacion?.lote!=''
                                                                              || datoOperacion?.nserie!='') ? 'tiene-linea-inferior': ''"
                             *ngIf="!datoOperacion?.sinConexion && !datoOperacion.tieneGrupos">
                          <ul>
                            <!-- nombre operacion -->
                            <li> <label class="home-label-maquina"> <strong>{{'of' |translate}} </strong> {{ datoOperacion?.numeroOF }} </label> </li>
                            <!-- cliente -->
                            <li *ngIf="datoOperacion?.cliente!=''"> <label class="home-label-maquina"> {{ datoOperacion?.cliente }} </label> </li>
                            <!-- pieza -->
                            <li *ngIf="datoOperacion?.pieza!=''"> <label class="home-label-maquina"> {{ datoOperacion?.pieza }} </label> </li>
                            <!-- nombre material -->
                            <!-- <li *ngIf="datoOperacion?.numeroOF!=''"> <label class="home-label-maquina"> {{ datoOperacion?.numeroOF }} </label> </li> -->
                            <!-- parte -->
                            <li *ngIf="datoOperacion?.nombreParte!=''"> <label class="home-label-maquina"> {{ datoOperacion?.nombreParte }} </label> </li>
                            <!-- operacion -->
                            <li *ngIf="datoOperacion?.nombreOperacion!=''"> <label class="home-label-maquina"> {{ datoOperacion?.nombreOperacion }} </label> </li>
                            <!-- nombre programa -->
                            <li *ngIf="maquina.home.nombrePrograma!=''"> <label class="home-label-maquina"> {{ maquina.home.nombrePrograma }} </label> </li>
                          </ul>

                          <div class="home-colada-lote-nserie"
                               *ngIf="datoOperacion?.colada!=''
                                                  || datoOperacion?.lote!=''
                                                  || datoOperacion?.nserie!='' ">
                            <!-- colada -->
                            <div class="home-colada-operacion" *ngIf="datoOperacion?.colada!=''">
                              <label title="{{ 'colada' | translate }}"> {{ 'colada' | translate }} </label>
                              <label title="{{ 'colada' | translate }}"> {{ datoOperacion?.colada }} </label>
                            </div>
                            <!-- lote -->
                            <div class="home-lote-operacion" *ngIf="datoOperacion?.lote!=''">
                              <label title="{{ 'lote' | translate }}"> {{ 'lote' | translate }} </label>
                              <label title="{{ 'lote' | translate }}"> {{ datoOperacion?.lote }} </label>
                            </div>
                            <!-- nserie -->
                            <div class="home-nserie-operacion" *ngIf="datoOperacion?.nserie!=''">
                              <label title="{{ 'nserie' | translate }}"> {{ 'nserie' | translate }} </label>
                              <label title="{{ 'nserie' | translate }}"> {{ datoOperacion?.nserie }} </label>
                            </div>
                          </div>
                        </div>

                        <!-- COL 1 SI TIENE GRUPOS -->
                        <div class="home-grupos-contenedor" *ngIf="datoOperacion.tieneGrupos">
                          <!-- Cabecera -->
                          <div class="home-cabecera-grupo">
                            <div class="home-grupo-nombre" title="{{datoOperacion.gruposOperaciones[0]?.nombreGrupo}}"><span>{{datoOperacion.gruposOperaciones[0]?.nombreGrupo}}</span></div>
                            <div class="home-grupo-cantidadOperaciones" title="{{datoOperacion.grupoCantidadOperaciones}}"><label><i class="icon-listado"></i>{{datoOperacion.grupoCantidadOperaciones}}</label></div>
                            <div class="home-grupo-cantidadPiezas" title="{{datoOperacion.grupoCantidadPiezas}}"><label><i class="icon-cubo"></i>{{datoOperacion.grupoCantidadPiezas}}</label></div>
                          </div>
                          <!-- Operaciones -->
                          <div class="home-operaciones-grupo">
                            <div *ngFor="let grupo of datoOperacion.gruposOperaciones">
                              

                              <!-- tooltip -->
                              <div class="tooltip-consumibles-contenido">
                                <div class="home-grupo-cantidad-operacion" [ngClass]="{'home-fondo-verde': grupo.colorCantidad=='verde', 'home-fondo-rojo': grupo.colorCantidad=='rojo'}" title="{{grupo.cantidad}}">
                                  <span>{{grupo.cantidad}}</span>
                                </div>
                                <div class="home-grupo-numeroOF-operacion" title="{{grupo.numeroOF}}"> <span>{{grupo.numeroOF}}</span> </div>
            
                                <!-- tooltip -->
                                <span class="tooltiptextHome text-left">
                                  <!-- cabecera -->
                                  <div class="tooltip-cabecera">
                                    <span><b>{{grupo.numeroOF}}</b></span>
                                    <div class="home-grupo-cantidad-operacion" [ngClass]="{'home-fondo-verde': grupo.colorCantidad=='verde', 'home-fondo-rojo': grupo.colorCantidad=='rojo'}" title="{{grupo.cantidad}}">
                                      <span>{{grupo.cantidad}}</span>
                                    </div>
                                  </div>

                                  <!-- informacion -->
                                  <span class="home-tooltip-nombrePieza" title="{{grupo.nombrePieza}}">{{grupo.nombrePieza}}</span>
                                  <span class="home-tooltip-nombreOperacion"title="{{grupo.nombreOperacion}}">{{grupo.nombreOperacion}}</span>

                                  <!-- informacion operacion -->
                                  <div class="home-grupos-info">
                                    <div class="home-grupos-peso"><label><i class="icon-peso"></i>{{datoOperacion.gruposOperaciones[0]?.peso}}/{{maquina.home.capacidadPesoMaximo}}</label></div>
                                    <div class="home-grupos-unidades"><label><i class="icon-equivalencia"></i>{{datoOperacion.gruposOperaciones[0]?.unidades}}/{{maquina.home.capacidadUnidadesMaximo}}</label></div>
                                    <div class="home-grupos-tiempoEstimado"><label><i class="icon-reloj"></i>{{myFunctions.secondsTo_HH_MM_SS(datoOperacion.gruposOperaciones[0]?.tiempoEstimado)}}</label></div>
                                    <div class="home-grupos-temperatura"><label><i class="icon-termometro2"></i>{{datoOperacion.gruposOperaciones[0]?.temperatura}}º</label></div>
                                  </div>
                                </span>
        
                              </div>
                            </div>
                          </div>
                          <!-- Informacion total -->
                          <div class="home-grupos-info">
                            <div class="home-grupos-peso"><label><i class="icon-peso"></i>{{datoOperacion.gruposOperaciones[0]?.pesoTotal}}/{{maquina.home.capacidadPesoMaximo}}</label></div>
                            <div class="home-grupos-unidades"><label><i class="icon-equivalencia"></i>{{datoOperacion.gruposOperaciones[0]?.unidadesTotal}}/{{maquina.home.capacidadUnidadesMaximo}}</label></div>
                            <div class="home-grupos-tiempoEstimado"><label><i class="icon-reloj"></i>{{myFunctions.secondsTo_HH_MM_SS(datoOperacion.gruposOperaciones[0]?.tiempoEstimadoTotal)}}</label></div>
                            <div class="home-grupos-temperatura"><label><i class="icon-termometro2"></i>{{datoOperacion.gruposOperaciones[0]?.temperaturaTotal}}º</label></div>
                          </div>
                        </div>

                        <!-- COL 2 CUANDO ES LOTE -->
                        <div class="home-informacion-pieza home-lote" *ngIf="datoOperacion?.cantidadReal > 1 && !datoOperacion?.sinConexion">

                          <!-- cantidades -->
                          <div class="home-cantidades-operacion">
                            <!-- piezas totales -->
                            <div class="home-piezas-totales-operacion">
                              <label class="titulo" title="{{ 'pTotales' | translate }}"> {{ 'pTotales' | translate }}</label>
                              <label class="valor" title="{{ 'pTotales' | translate }}"> {{ datoOperacion?.cantidadReal}} </label>
                            </div>
                            <!-- contador -->
                            <div class="home-contador-operacion">
                              <label class="titulo" title="{{ 'contador' | translate }}"> {{ 'contador' | translate }}</label>
                              <label class="valor" title="{{ 'contador' | translate }}"> {{ datoOperacion?.contadorEstimadoConPreparacion}} </label>
                            </div>
                            <!-- manual -->
                            <div class="home-manual-operacion">
                              <label class="titulo" title="{{ 'manual' | translate }}"> {{ 'manual' | translate }}</label>
                              <label class="valor" title="{{ 'manual' | translate }}"> {{ datoOperacion?.cantidadManual +  datoOperacion?.contadorTotalOperacionManualPreparacion }} </label>
                            </div>
                            <!-- malas -->
                            <div class="home-malas-operacion">
                              <label class="titulo" title="{{ 'malas' | translate }}"> {{ 'malas' | translate }}</label>
                              <label class="valor" title="{{ 'malas' | translate }}"> {{ datoOperacion?.cantidadMalas }} </label>
                            </div>
                          </div>

                          <!-- actual/ritmo -->
                          <div class="home-pieza-actual-ritmo-contenedor">
                            <div *ngIf="maquina.home.loadingTiempos && !loading" class="k-i-loading"></div>
                            <div class="home-actual-ritmo">
                              <div class="home-actual-ritmo-inner">

                                <div class="hueco"></div>
                                <div class="cont-titulo-actual">
                                  <i class="icon-tiempo-actual"></i>
                                  <label title="{{ 'actual' |translate }}">{{ 'actual' |translate }}</label>
                                </div>
                                <div class="cont-titulo-ritmo">
                                  <i class="icon-ritmo"></i>
                                  <label title="{{ 'ritmo' |translate }}">{{ 'ritmo' |translate }}</label>
                                </div>

                              </div>

                              <div class="borde-fake"></div>

                            </div>

                            <!-- Preparacion -->
                            <div class="home-preparacion-pieza-lote">
                              <div class="home-titulo-vertical">
                                <div class="cont-label-icon">
                                  <i class="icon-preparacion"></i>
                                  <label title="{{ 'prep.' | translate }}">{{ 'prep.' | translate }}</label>
                                </div>
                                <div class="borde-fake borde-degradado-top"></div>
                              </div>
                              <div class="home-datos-actual">
                                <!-- real -->
                                <label class="home-tiempo-grande" [ngClass]="datoOperacion?.tiempoPreparacionRojo ? 'home-tiempo-superior': 'home-tiempo-inferior'" *ngIf="maquina.home.idEstado!=3"> {{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoPreparacion) }} </label>
                                <label class="home-tiempo-grande" [ngClass]="datoOperacion?.tiempoPreparacionRojo ? 'home-tiempo-superior': 'home-tiempo-inferior'" *ngIf="maquina.home.idEstado==3"> {{ timeDiff(datoOperacion?.tiempoPreparacion, datoOperacion?.horaServidorTiempos) }} </label>
                            
                                <!-- predictivo -->
                                <label class="home-tiempo"> ({{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoEstimadoPreparacion) }}) </label>
                              </div>
                              <div class="home-datos-ritmo">

                                <div class="etiqueta" [ngClass]="datoOperacion?.tiempoPreparacionRojo ? 'home-fondo-rojo': 'home-fondo-verde'">

                                  <!-- desvio -->
                                  <label class=""> {{ datoOperacion?.desvioPreparacion }} </label>
                                  <i class="icon-reloj"></i>

                                </div>

                              </div>
                            </div>
                            <!-- Pieza -->
                            <div class="home-preparacion-pieza-lote">
                              <div class="home-titulo-vertical">
                                <div class="cont-label-icon">
                                  <i class="icon-pieza"></i>
                                  <label title="{{ 'pieza' | translate }}">{{ 'pieza' | translate }}</label>
                                </div>
                                <div class="borde-fake"></div>
                              </div>
                              <div class="home-datos-actual">
                                <!-- real -->
                                <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado!=3"> {{ timeDiff(datoOperacion?.tiempoActualPieza, datoOperacion?.horaServidorTiempos) }} </label>
                                <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado==3"> {{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoActualPieza) }} </label>
                                <!-- <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado==3"> NA </label> -->
                                <!-- porcentaje -->
                                <div class="home-contenedor-porcentaje">
                                  <div class="home-barra-progreso" [ngStyle]="{'width': datoOperacion?.porcentajeActualPieza +'%'}"></div>

                                  <label class="home-label-progreso"> {{ datoOperacion?.porcentajeActualPieza }}% </label>

                                </div>
                              </div>
                              <div class="home-datos-ritmo">
                                <!-- real -->
                                <label class="home-tiempo-grande" [ngClass]="datoOperacion?.tiempoPiezaRojo ? 'home-tiempo-superior': 'home-tiempo-inferior'" *ngIf="datoOperacion?.contadorTotalOperacionAutomatico!=0 || datoOperacion?.cantidadManual!=0"> {{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoPiezaRitmo) }} </label>
                                <label class="home-tiempo-grande" *ngIf="datoOperacion?.contadorTotalOperacionAutomatico==0 && datoOperacion?.cantidadManual==0"> NA </label>

                                <!-- predictivo -->
                                <label class="home-tiempo"> ({{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoRitmoPiezaEstimado) }}) </label>
                                <!-- <label class="home-tiempo" *ngIf="maquina.home.idEstado==3"> (NA) </label> -->
                                <div class="etiqueta" [ngClass]="{'home-fondo-verde': (!datoOperacion?.tiempoPiezaRojo && (datoOperacion?.contadorTotalOperacionAutomatico!=0 || datoOperacion?.cantidadManual!=0)), 'home-fondo-rojo': (datoOperacion?.tiempoPiezaRojo && (datoOperacion?.contadorTotalOperacionAutomatico!=0 || datoOperacion?.cantidadManual!=0))}">
                                  <!-- desvio -->
                                  <label class=""> {{ datoOperacion?.desvioPieza }} </label>
                                  <i class="icon-reloj"></i>
                                </div>
                              </div>
                            </div>
                            <!-- Circulo del porcentaje -->
                            <div class="home-circulo-porcentaje-cont" [ngClass]="{'home-fondo-verde': ((datoOperacion?.porcentajePiezaCentral) < 0 && (datoOperacion?.contadorEstimado!=0 || datoOperacion?.cantidadManual!=0) && maquina.home.idEstado!=3), 'home-fondo-rojo': ((datoOperacion?.porcentajePiezaCentral) > 0 && (datoOperacion?.contadorEstimado!=0 || datoOperacion?.cantidadManual!=0) && maquina.home.idEstado!=3)}">
                              <!-- aldatzeko -->
                              <div class="home-circulo-porcentaje">
                                <label class="home-label-porcentaje" *ngIf="(datoOperacion?.contadorEstimado!=0 || datoOperacion?.cantidadManual!=0) && (datoOperacion?.porcentajePiezaCentral) < 0"> {{ datoOperacion?.porcentajePiezaCentral.toString().substring(1) }}% </label>
                                <label class="home-label-porcentaje" *ngIf="(datoOperacion?.contadorEstimado!=0 || datoOperacion?.cantidadManual!=0) && (datoOperacion?.porcentajePiezaCentral) >= 0"> {{ datoOperacion?.porcentajePiezaCentral }}% </label>
                                <!-- <label class="home-label-porcentaje" *ngIf="datoOperacion?.contadorTotalOperacionAutomatico==0 && datoOperacion?.cantidadManual==0"> NA </label> -->
                                <label class="home-label-porcentaje" *ngIf="datoOperacion?.contadorEstimado==0 && datoOperacion?.cantidadManual==0"> NA </label>
                              </div>
                            </div>
                            <!-- Lote -->
                            <div class="home-preparacion-pieza-lote">
                              <div class="home-titulo-vertical">

                                <div class="cont-label-icon">
                                  <i class="icon-piezas-totales"></i>
                                  <label title="{{ 'lote' | translate }}">{{ 'lote' | translate }}</label>
                                </div>

                                <div class="borde-fake borde-degradado-bottom"></div>
                              </div>
                              <div class="home-datos-actual">
                                <!-- real -->
                                <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado!=3 || maquina.home.home_tipoCalculoLote == 3"> {{ timeDiff(datoOperacion?.tiempoActualLote, datoOperacion?.horaServidorTiempos) }} </label>
                                <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado==3 && maquina.home.home_tipoCalculoLote!=3"> {{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoActualLote) }} </label>
                                <!-- <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado==3"> NA </label> -->
                                <!-- porcentaje -->
                                <div class="home-contenedor-porcentaje">
                                  <div class="home-barra-progreso" [ngStyle]="{'width': datoOperacion?.porcentajeActualLote +'%'}"></div>
                                  <label class="home-label-progreso"> {{ datoOperacion?.porcentajeActualLote }}% </label>
                                </div>
                              </div>
                              <div class="home-datos-ritmo">
                                <!-- real -->
                                <label class="home-tiempo-grande" [ngClass]="datoOperacion?.tiempoLoteRojo ? 'home-tiempo-superior': 'home-tiempo-inferior'" *ngIf="datoOperacion?.contadorTotalOperacionAutomatico!=0 || datoOperacion?.cantidadManual!=0"> {{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoRitmoLote) }} </label>
                                <label class="home-tiempo-grande" *ngIf="datoOperacion?.contadorTotalOperacionAutomatico==0 && datoOperacion?.cantidadManual==0"> NA </label>
                                <!-- predictivo -->
                                <label class="home-tiempo"> ({{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoRitmoLoteEstimadoEnsennar) }}) </label>
                                <!-- <label class="home-tiempo" *ngIf="maquina.home.idEstado==3"> (NA) </label> -->
                                <div class="etiqueta" [ngClass]="{'home-fondo-verde': (!datoOperacion?.tiempoLoteRojo && (datoOperacion?.contadorTotalOperacionAutomatico!=0 || datoOperacion?.cantidadManual!=0)), 'home-fondo-rojo': (datoOperacion?.tiempoLoteRojo && (datoOperacion?.contadorTotalOperacionAutomatico!=0 || datoOperacion?.cantidadManual!=0))}">
                                  <!-- desvio -->
                                  <label class=""> {{ datoOperacion?.desvioLote }} </label>
                                  <i class="icon-reloj"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- COL 2 CUANDO NO ES LOTE -->
                        <div class="home-informacion-pieza home-no-lote" *ngIf="datoOperacion?.cantidadReal <= 1 && !datoOperacion?.sinConexion">

                          <div class="home-pieza-actual-ritmo-contenedor">
                            <div *ngIf="maquina.home.loadingTiempos && !loading" class="k-i-loading"></div>

                            <!-- actual -->
                            <div class="home-actual">

                              <div class="home-actual-inner">

                                <i class="icon-tiempo-actual"></i>
                                <label title="{{ 'actual' |translate }}">{{ 'actual' |translate }}</label>

                              </div>

                              <div class="borde-fake"></div>

                            </div>
                            <!-- Preparacion -->
                            <div class="home-preparacion-pieza-lote">
                              <div class="home-titulo-vertical">
                                <div class="cont-label-icon">

                                  <i class="icon-preparacion"></i>
                                  <label title="{{ 'prep.' | translate }}">{{ 'prep.' | translate }}</label>

                                </div>
                                <div class="borde-fake borde-degradado-top"></div>
                              </div>
                              <div class="home-datos-actual">
                                <!-- real -->
                                <label class="home-tiempo-grande" [ngClass]="datoOperacion?.tiempoPreparacionRojo ? 'home-tiempo-superior': 'home-tiempo-inferior'" *ngIf="maquina.home.idEstado!=3"> {{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoPreparacion) }} </label>
                                <label class="home-tiempo-grande" [ngClass]="datoOperacion?.tiempoPreparacionRojo ? 'home-tiempo-superior': 'home-tiempo-inferior'" *ngIf="maquina.home.idEstado==3"> {{ timeDiff(datoOperacion?.tiempoPreparacion, datoOperacion?.horaServidorTiempos) }} </label>
                                <!-- predictivo -->
                                <label class="home-tiempo"> ({{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoEstimadoPreparacion) }}) </label>
                              </div>
                              <div class="home-datos-ritmo">
                                <!-- desvio -->
                                <span class="etiqueta" [ngClass]="datoOperacion?.tiempoPreparacionRojo ? 'home-fondo-rojo': 'home-fondo-verde'">
                                  <label class=""> {{ datoOperacion?.desvioPreparacion }} </label>
                                  <i class="icon-reloj"></i>
                                </span>
                              </div>
                            </div>

                            <!-- Pieza -->
                            <div class="home-preparacion-pieza-lote">
                              <div class="home-titulo-vertical">
                                <div class="cont-label-icon">
                                  <i class="icon-pieza"></i>
                                  <label title="{{ 'pieza' | translate }}">{{ 'pieza' | translate }}</label>
                                </div>
                                <div class="borde-fake"></div>
                              </div>
                              <div class="home-datos-actual">
                                <!-- real -->
                                <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado!=3"> {{ timeDiff(datoOperacion?.tiempoActualPieza, datoOperacion?.horaServidorTiempos) }} </label>
                                <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado==3"> {{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoActualPieza) }} </label>
                                <!-- <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado==3"> NA </label> -->
                                <!-- predictivo -->
                                <label class="home-tiempo"> ({{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoRitmoPiezaEstimado) }}) </label>
                                <!-- <label class="home-tiempo" *ngIf="maquina.home.idEstado==3"> (NA) </label> -->
                              </div>
                              <div class="home-datos-ritmo">
                                <!-- desvio -->
                                <span class="etiqueta" [ngClass]="{'home-fondo-rojo': (datoOperacion?.tiempoPiezaRojo && maquina.home.idEstado!=3),  'home-fondo-verde': !datoOperacion?.tiempoPiezaRojo}">
                                  <label class=""> {{ datoOperacion?.desvioPieza }} </label>
                                  <i class="icon-reloj"></i>
                                </span>
                              </div>
                            </div>

                            <!-- Circulo del porcentaje -->
                            <div class="home-circulo-porcentaje-cont" [ngClass]="{'home-fondo-verde': ((datoOperacion?.porcentajePiezaCentral) < 0 && (datoOperacion?.contadorEstimado!=0 || datoOperacion?.cantidadManual!=0) && maquina.home.idEstado!=3), 'home-fondo-rojo': ((datoOperacion?.porcentajePiezaCentral) > 0 && (datoOperacion?.contadorEstimado!=0 || datoOperacion?.cantidadManual!=0) && maquina.home.idEstado!=3)}">
                              <div class="home-circulo-porcentaje">
                                <label class="home-label-porcentaje" *ngIf="(datoOperacion?.porcentajePiezaCentral) < 0"> {{ datoOperacion?.porcentajePiezaCentral.toString().substring(1) }}% </label>
                                <label class="home-label-porcentaje" *ngIf="(datoOperacion?.porcentajePiezaCentral) >= 0"> {{ datoOperacion?.porcentajePiezaCentral }}% </label>
                                <!-- <label class="home-label-porcentaje" *ngIf="maquina.home.idEstado==3"> NA </label> -->
                              </div>
                            </div>
                            <!-- Lote -->
                            <div class="home-preparacion-pieza-lote">
                              <div class="home-titulo-vertical">
                                <div class="cont-label-icon">
                                  <i class="icon-piezas-totales"></i>
                                  <label title="{{ 'total' | translate }}">{{ 'total' | translate }}</label>
                                </div>
                                <div class="borde-fake borde-degradado-bottom"></div>
                              </div>
                              <div class="home-datos-actual">
                                <!-- real -->
                                <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado!=3"> {{ timeDiff(datoOperacion?.tiempoActualLote, datoOperacion?.horaServidorTiempos) }} </label>
                                <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado==3"> {{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoActualLote) }} </label>
                                <!-- <label class="home-tiempo-grande" *ngIf="maquina.home.idEstado==3"> NA </label> -->
                                <!-- predictivo -->
                                <label class="home-tiempo"> ({{ myFunctions.secondsTo_HH_MM_SS(datoOperacion?.tiempoRitmoLoteEstimadoEnsennar) }}) </label>
                                <!-- <label class="home-tiempo" *ngIf="maquina.home.idEstado==3"> (NA) </label> -->
                              </div>
                              <div class="home-datos-ritmo">
                                <!-- desvio -->
                                <span class="etiqueta" [ngClass]="{'home-fondo-rojo': (datoOperacion?.tiempoLoteRojo && maquina.home.idEstado!=3),  'home-fondo-verde': !datoOperacion?.tiempoPiezaRojo}">
                                  <label class=""> {{ datoOperacion?.desvioLote }} </label>
                                  <i class="icon-reloj"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!-- <a class="carousel-control-prev" href="{{'#carouselExampleIndicators_'+ maquina.id}}" role="button" data-slide="prev">
              </a>
              <a class="carousel-control-next" id="{{'carousel-control-next_' + maquina.id}}" href="{{'#carouselExampleIndicators_'+ maquina.id}}" role="button" data-slide="next">
              </a> -->
            </div>

            <!-- SI NO TIENE OPERACIONES O CONEXION -->
            <div class="home-operaciones-contenedor" (click)="redirigirAProceso(maquina.id, maquina.tipo_maquina, maquina.puestoOffline)" >
              <div class="home-operacion-contenedor">
                <!-- COL 1 SI NO TIENE OF NI CONEXION -->
                <div class="home-informacion-operacion" *ngIf="maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion">
                  <!-- imagen de of no identificado -->
                  <div class="home-imagen-sin-datos" *ngIf="maquina.home.datosOperaciones.length==0 && !maquina.home.sinConexion">
                    <img src="../../../assets/img/imagen-of-no-asignada.png" />
                  </div>
                  <div class="home-imagen-sin-datos" *ngIf="maquina.home.sinConexion">
                    <img src="../../../assets/img/imagen-maquina-sin-conexion.png" />
                  </div>
                </div>

                <!--COL 2 CUANDO NO TIENE OF NI CONEXION-->
                <div class="home-informacion" *ngIf="maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion">

                  <label title="{{'ofNoIdentificado' | translate}}" *ngIf="maquina.home.datosOperaciones.length==0 && !maquina.home.sinConexion">{{'ofNoIdentificado' | translate}}</label>
                  <label title="{{'nombrePrograma' | translate}}" *ngIf="maquina.home.datosOperaciones.length==0 && !maquina.home.sinConexion && maquina.home.nombrePrograma != ''">({{maquina.home.nombrePrograma}})</label>
                  <label title="{{'nombrePrograma' | translate}}" *ngIf="maquina.home.datosOperaciones.length==0 && !maquina.home.sinConexion && maquina.home.nombrePrograma == ''">({{'nohaydatosprograma' | translate}})</label>

                  <label title="{{'sinConexion' | translate}}" *ngIf="maquina.home.sinConexion">{{'sinConexion' | translate}}</label>

                  <div class="home-tiempo-estado-maquina">
                    <kendo-label text="{{ timeDiff(maquina.home.tiempoEstado, maquina.home.now) }}"></kendo-label>                
                  </div>
                </div>
              </div>
            </div>
            <!-- INFORMACION CONFIGURABLE -->
            <div class="home-informacion-configurable">

              <!-- COL IZQUIERDA -->
              <div class="home-inf-conf-col-izquierda">
                  <!-- OEE Y PARAMETROS DE MAQUINA -->
                  <div class="home-cuatro-graficos donuts-argiak" *ngIf="[1,2,3,7].includes(maquina.home.idHomeSeleccionIzq)" (click)="redirigirAOEE(maquina.id, maquina.home.idHomeSeleccionIzq)"
                          [ngClass]="[1,2,3].includes(maquina.home.idHomeSeleccionIzq) ? 'home-oee': 'home-parametros'">
                    <div class="cont-home-donuts">
                      <div *ngIf="!maquina.col1_datosCargados_1 && !loading" class="k-i-loading"></div>
                      <!-- donut 1 -->
                      <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionIzq != 7 || (maquina.home.idHomeSeleccionIzq == 7 && maquina.home.idEje1 != -1)">
                        <!-- <div class="home-donut" id="{{'argia-col1_1_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col1_ensennarGrafico_1 && maquina.home.idHomeSeleccionIzq == 7) || maquina.home.idHomeSeleccionIzq != 7)}"></div> -->
                        <div class="home-donut" id="{{'argia-col1_1_'+maquina.id}}"></div>  
                        <div class="valores-home-donut">
                          <label class="valor-home-donut">{{maquina.col1_value_1}}</label>
                          <label class="label-home-donut">{{maquina.col1_label_1}}</label>
                        </div>
                      </div>
                        
                      <!-- donut 2 -->
                      <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionIzq != 7 || (maquina.home.idHomeSeleccionIzq == 7 && maquina.home.idEje2 != -1)">
                        <!-- <div class="home-donut" id="{{'argia-col2_1_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col2_ensennarGrafico_1 && maquina.home.idHomeSeleccionIzq == 7) || maquina.home.idHomeSeleccionIzq != 7)}"></div> -->
                        <div class="home-donut" id="{{'argia-col2_1_'+maquina.id}}"></div>  
                        <div class="valores-home-donut">
                          <label class="valor-home-donut">{{maquina.col2_value_1}}</label>
                          <label class="label-home-donut">{{maquina.col2_label_1}}</label>
                        </div>
                      </div>
                      
                      <!-- donut 3 -->
                      <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionIzq != 7 || (maquina.home.idHomeSeleccionIzq == 7 && maquina.home.idEje3 != -1)">
                        <!-- <div class="home-donut" id="{{'argia-col3_1_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col3_ensennarGrafico_1 && maquina.home.idHomeSeleccionIzq == 7) || maquina.home.idHomeSeleccionIzq != 7)}"></div> -->
                        <div class="home-donut" id="{{'argia-col3_1_'+maquina.id}}"></div>  
                        <div class="valores-home-donut">
                          <label class="valor-home-donut">{{maquina.col3_value_1}}</label>
                          <label class="label-home-donut">{{maquina.col3_label_1}}</label>
                        </div>
                      </div>
                      
                      <!-- donut 4 -->
                      <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionIzq != 7 || (maquina.home.idHomeSeleccionIzq == 7 && maquina.home.idEje4 != -1)">
                        <!-- <div class="home-donut" id="{{'argia-col4_1_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col4_ensennarGrafico_1 && maquina.home.idHomeSeleccionIzq == 7) || maquina.home.idHomeSeleccionIzq != 7)}"></div> -->
                        <div class="home-donut" id="{{'argia-col4_1_'+maquina.id}}"></div>  
                        <div class="valores-home-donut">
                          <label class="valor-home-donut">{{maquina.col4_value_1}}</label>
                          <label class="label-home-donut">{{maquina.col4_label_1}}</label>
                        </div>
                      </div> 
                    </div>
                  </div>

                  <div class="home-cuatro-graficos donuts-ilunak"  *ngIf="[1,2,3,7].includes(maquina.home.idHomeSeleccionIzq)" (click)="redirigirAOEE(maquina.id, maquina.home.idHomeSeleccionIzq)"
                      [ngClass]="[1,2,3].includes(maquina.home.idHomeSeleccionIzq) ? 'home-oee': 'home-parametros'">
                    <div class="cont-home-donuts">
                      <div *ngIf="!maquina.col1_datosCargados_1 && !loading" class="k-i-loading"></div>
                      <!-- donut 1 -->
                      <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionIzq != 7 || (maquina.home.idHomeSeleccionIzq == 7 && maquina.home.idEje1 != -1)">
                        <!-- <div class="home-donut" id="{{'iluna-col1_1_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col1_ensennarGrafico_1 && maquina.home.idHomeSeleccionIzq == 7) || maquina.home.idHomeSeleccionIzq != 7)}"></div> -->
                        <div class="home-donut" id="{{'iluna-col1_1_'+maquina.id}}"></div>  
                        <div class="valores-home-donut">
                          <label class="valor-home-donut">{{maquina.col1_value_1}}</label>
                          <label class="label-home-donut">{{maquina.col1_label_1}}</label>
                        </div>
                      </div>
                        
                      <!-- donut 2 -->
                      <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionIzq != 7 || (maquina.home.idHomeSeleccionIzq == 7 && maquina.home.idEje2 != -1)">
                        <!-- <div class="home-donut" id="{{'iluna-col2_1_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col2_ensennarGrafico_1 && maquina.home.idHomeSeleccionIzq == 7) || maquina.home.idHomeSeleccionIzq != 7)}"></div> -->
                        <div class="home-donut" id="{{'iluna-col2_1_'+maquina.id}}"></div>  
                        <div class="valores-home-donut">
                          <label class="valor-home-donut">{{maquina.col2_value_1}}</label>
                          <label class="label-home-donut">{{maquina.col2_label_1}}</label>
                        </div>
                      </div>
                      
                      <!-- donut 3 -->
                      <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionIzq != 7 || (maquina.home.idHomeSeleccionIzq == 7 && maquina.home.idEje3 != -1)">
                        <!-- <div class="home-donut" id="{{'iluna-col3_1_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col3_ensennarGrafico_1 && maquina.home.idHomeSeleccionIzq == 7) || maquina.home.idHomeSeleccionIzq != 7)}"></div> -->
                        <div class="home-donut" id="{{'iluna-col3_1_'+maquina.id}}"></div>  
                        <div class="valores-home-donut">
                          <label class="valor-home-donut">{{maquina.col3_value_1}}</label>
                          <label class="label-home-donut">{{maquina.col3_label_1}}</label>
                        </div>
                      </div>
                      
                      <!-- donut 4 -->
                      <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionIzq != 7 || (maquina.home.idHomeSeleccionIzq == 7 && maquina.home.idEje4 != -1)">
                        <!-- <div class="home-donut" id="{{'iluna-col4_1_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col4_ensennarGrafico_1 && maquina.home.idHomeSeleccionIzq == 7) || maquina.home.idHomeSeleccionIzq != 7)}"></div> -->
                        <div class="home-donut" id="{{'iluna-col4_1_'+maquina.id}}"></div>  
                        <div class="valores-home-donut">
                          <label class="valor-home-donut">{{maquina.col4_value_1}}</label>
                          <label class="label-home-donut">{{maquina.col4_label_1}}</label>
                        </div>
                      </div> 
                    </div>
                  </div>

                  <!-- Resumen -->
                  <div class="home-resumen-semana" *ngIf="[4,5,6].includes(maquina.home.idHomeSeleccionIzq)" (click)="redirigirRendimiento(maquina.id)">
                    <div *ngIf="!maquina.col1_datosCargados_1 && !loading" class="k-i-loading"></div>
                    <label>{{'resumensemana' | translate }}</label>
                    <div class="tooltip-consumibles-contenido">
                      <div class="graf-barr-part-cont "  id="barra1">
                        <div class="graf-barr-part-multi fondo-color-preparacion" id="barraTiemposPorcentajePreparacion" [style.width.%]="(maquina.TPorcentajePreparacion)">
                        </div>
                        <div class="graf-barr-part-multi fondo-color-ejecucion" id="barraTiemposPorcentajeEjecucion" [style.width.%]="(maquina.TPorcentajeEjecucion)" >
                        </div>
                        <div class="graf-barr-part-multi fondo-color-parada" id="barraTiemposPorcentajeParada" [style.width.%]="(maquina.TPorcentajeParada)" >
                        </div>
                        <div class="graf-barr-part-multi fondo-color-mantenimiento" id="barraTiemposPorcentajeMantenimiento" [style.width.%]="(maquina.TPorcentajeMantenimiento)">
                        </div>
                        <div class="graf-barr-part-multi fondo-color-alarma" id="barraTiemposPorcentajeAlarma" [style.width.%]="(maquina.TPorcentajeAlarma)">
                        </div>
                        <div class="graf-barr-part-multi fondo-color-apagada" id="barraTiemposPorcentajeApagado" [style.width.%]="(maquina.TPorcentajeApagado)">
                        </div>
                        <div class="graf-barr-part-multi fondo-color-microparada" id="barraTiemposPorcentajeMicroparada" [style.width.%]="(maquina.TPorcentajeMicroParada)">
                        </div>
                      </div>
  
                      <!-- tooltip -->
                      <span class="tooltiptextHome text-left"  >
                        <div class="tooltipDestacado info_preparacion" *ngIf="maquina.TPorcentajePreparacion > 0">
                        <label class="home-tooltip-titulo">{{ 'preparacion' | translate }}</label>
                        <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TPreparacion)}}</label>
                        <label class="home-tooltip-valor">{{maquina.TPorcentajePreparacion}}%</label>
                        </div>
                        
                        <div class="tooltipDestacado info_ejecucion" *ngIf="maquina.TPorcentajeEjecucion > 0">
                        <label class="home-tooltip-titulo">{{ 'ejecucion' | translate }}</label>
                        <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TEjecucion)}}</label>
                        <label class="home-tooltip-valor">{{maquina.TPorcentajeEjecucion}}%</label>
                        </div>
                        <div class="tooltipDestacado info_parada" *ngIf="maquina.TPorcentajeParada > 0">
                        <label class="home-tooltip-titulo">{{ 'parada' | translate }}</label>
                        <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TParada)}}</label>
                        <label class="home-tooltip-valor">{{maquina.TPorcentajeParada}}%</label>
                        </div>
                        <div class="tooltipDestacado info_mantenimiento" *ngIf="maquina.TPorcentajeMantenimiento > 0">
                        <label class="home-tooltip-titulo">{{ 'mantenimiento' | translate }}</label>
                        <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TMantenimiento)}}</label>
                        <label class="home-tooltip-valor">{{maquina.TPorcentajeMantenimiento}}%</label>
                        </div>
                        <div class="tooltipDestacado info_alarma" *ngIf="maquina.TPorcentajeAlarma > 0">
                        <label class="home-tooltip-titulo">{{ 'alarma' | translate }}</label>
                        <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TAlarma)}}</label>
                        <label class="home-tooltip-valor">{{maquina.TPorcentajeAlarma}}%</label>
                        </div>
                        <div class="tooltipDestacado info_apagada" *ngIf="maquina.TPorcentajeApagado > 0">
                        <label class="home-tooltip-titulo">{{ 'apagada' | translate }}</label>
                        <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TApagado)}}</label>
                        <label class="home-tooltip-valor">{{maquina.TPorcentajeApagado}}%</label>
                        </div>
                        <div class="tooltipDestacado info_microparada" *ngIf="maquina.TPorcentajeMicroParada > 0">
                        <label class="home-tooltip-titulo">{{ 'microparada' | translate }}</label>
                        <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TMicroParada)}}</label>
                        <label class="home-tooltip-valor">{{maquina.TPorcentajeMicroParada}}%</label>
                        </div>
                      </span>

                    </div>
                  </div>
                  <!-- Datos por hora -->
                  <div class="home-euros-hora-cont" *ngIf="[8,9,10].includes(maquina.home.idHomeSeleccionIzq)">
                      <div class="home-titulo-vertical">
                          <label title="{{ 'diaTotal' | translate }}">{{ 'diaTotal' | translate }}</label>
                      </div>
                      <!--€/h-->
                      <div class="home-euros-hora">
                          <label class="titulo" title="{{ 'eurosHoraAbrev' | translate }}">{{ 'eurosHoraAbrev' | translate }}</label>
                          <label class="home-valor-grande" title="{{ 'eurosHoraAbrev' | translate }}">{{ maquina.home.eurosHora }}</label>
                          <label class="diferencia" title="{{ 'eurosHoraAbrev' | translate }}" [ngClass]="!maquina.home.eurosHoraRojo ? 'home-label-verde': 'home-label-rojo'">{{ maquina.home.eurosHoraEstimado }}</label>
                      </div>
                      <!-- Circulo del porcentaje -->
                      <div class="home-circulo-porcentaje-hora-cont" [ngClass]="!maquina.home.porcentajeEurosHoraRojo ? 'home-fondo-verde': 'home-fondo-rojo'">
                          <div class="home-circulo-porcentaje">
                            <label class="home-label-porcentaje"> {{ maquina.home.porcentajeEurosHora }}% </label>
                          </div>
                      </div>
                      <!--Piezas/h-->
                      <div class="piezas-euros-hora">
                          <label class="titulo" title="{{ 'piezasHoraAbrev' | translate }}">{{ 'piezasHoraAbrev' | translate }}</label>
                          <label class="home-valor-grande" title="{{ 'piezasHoraAbrev' | translate }}">{{ maquina.home.piezasHora }}</label>
                          <label class="diferencia" title="{{ 'piezasHoraAbrev' | translate }}" [ngClass]="!maquina.home.piezasHoraRojo ? 'home-label-verde': 'home-label-rojo'">{{ maquina.home.piezasHoraEstimado }}</label>
                      </div>
                  </div>
                  <!-- Informacion turnos -->
                  <div class="home-turno-contenedor" *ngIf="[11].includes(maquina.home.idHomeSeleccionIzq)">
                    <div *ngIf="isNaN(maquina.home.datosOperaciones[0]?.tiempoActualTurno)" class="k-i-loading"></div>
                    <div class="home-actual-ritmo">
                      <!-- Turno -->
                      <div class="home-preparacion-pieza-lote">
                        <div class="home-titulo-vertical">
                          <div class="cont-label-icon">
                            <i class="icon-turnos"></i>
                            <label title="{{ 'pieza' | translate }}">{{ 'turno' | translate }}</label>
                          </div>

                          <div class="borde-fake borde-degradado-bottom"></div>
                        </div>
                        <div class="home-datos-actual">
                          <!-- real -->
                          <label *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion" class="home-tiempo-grande"> {{ timeDiff(maquina.home.datosOperaciones[0]?.tiempoActualTurno, maquina.home.datosOperaciones[0]?.horaServidorTiempos) }} </label>
                          <label *ngIf="(maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion)" class="home-tiempo-grande">NA</label>
                          <!-- cantidad de piezas -->
                          <div class="home-cantidad-turno">
                            <i class="icon-piezas-totales"></i>
                            <span *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion" class="home-cantidad-correcto">{{ maquina.home.datosOperaciones[0]?.cantidadTurno }}</span>
                            <span *ngIf="(maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion)" class="home-cantidad-correcto">0</span>

                            <span *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion">(<span class="home-cantidad-malas">{{ maquina.home.datosOperaciones[0]?.cantidadTurnoMal }}</span>)</span>
                            <span *ngIf="(maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion)">(<span  class="home-cantidad-malas">0</span>)</span>
                          </div>
                        </div>
                        <div class="home-datos-ritmo">
                          <!-- real -->
                          <label class="home-tiempo-grande" [ngClass]="maquina.home.datosOperaciones[0]?.tiempoTurnoRojo ? 'home-tiempo-superior': 'home-tiempo-inferior'" *ngIf="maquina.home.datosOperaciones[0]!=0 && maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion &&maquina.home.datosOperaciones[0]?.cantidadTurno!=0"> {{ myFunctions.secondsTo_HH_MM_SS(maquina.home.datosOperaciones[0]?.tiempoRitmoTurno) }} </label>
                          <label class="home-tiempo-grande" *ngIf="maquina.home.datosOperaciones[0]==0 || (maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion || maquina.home.datosOperaciones[0]?.cantidadTurno==0)"> NA </label>
                    
                          <!-- predictivo -->
                          <label *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion && maquina.home.datosOperaciones[0]?.cantidadTurno!=0" class="home-tiempo"> ({{myFunctions.secondsTo_HH_MM_SS(maquina.home.datosOperaciones[0]?.tiempoRitmoTurnoEstimado)}}) </label>
                          <label *ngIf="(maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion) || maquina.home.datosOperaciones[0]?.cantidadTurno==0" class="home-tiempo"> (NA) </label>
                          <div class="etiqueta" [ngClass]="{'home-fondo-verde': (!maquina.home.datosOperaciones[0]?.tiempoTurnoRojo && maquina.home.datosOperaciones[0]!=0), 'home-fondo-rojo': (maquina.home.datosOperaciones[0]?.tiempoTurnoRojo && maquina.home.datosOperaciones[0]!=0)}">
                          <!-- desvio -->
                          <label *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion && maquina.home.datosOperaciones[0]?.cantidadTurno!=0"> {{ myFunctions.secondsTo_HHh_MM(maquina.home.datosOperaciones[0]?.desvioTurno) }} </label>
                          <label *ngIf="(maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion || maquina.home.datosOperaciones[0]?.cantidadTurno==0)"> {{ myFunctions.secondsTo_HHh_MM(0) }} </label>
                          <i class="icon-reloj"></i>
                          </div>
                        </div>
                      </div>
                      <!-- Circulo del porcentaje -->
                      <div class="home-circulo-porcentaje-cont" [ngClass]="{'home-fondo-verde': ((maquina.home.datosOperaciones[0]?.porcentajeTurno - 100) < 0 && maquina.home.datosOperaciones[0]!=0), 'home-fondo-rojo': ((maquina.home.datosOperaciones[0]?.porcentajeTurno - 100) > 0 && maquina.home.datosOperaciones[0]!=0)}">
                        <!-- aldatzeko -->
                        <div class="home-circulo-porcentaje">
                          <label class="home-label-porcentaje" *ngIf="maquina.home.datosOperaciones[0]!=0 && maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion && maquina.home.datosOperaciones[0]?.cantidadTurno!=0"> {{(maquina.home.datosOperaciones[0]?.porcentajeTurno - 100).toFixed(1)}}% </label>
                          <label class="home-label-porcentaje" *ngIf="maquina.home.datosOperaciones[0]==0 || !(maquina.home.datosOperaciones.length!=0 || maquina.home.sinConexion) || maquina.home.datosOperaciones[0]?.cantidadTurno==0"> NA </label>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>

              <!-- COL DERECHA -->
              <div class="home-inf-conf-col-derecha">
                <!-- OEE Y PARAMETROS DE MAQUINA -->
                <div class="home-cuatro-graficos donuts-argiak" *ngIf="[1,2,3,7].includes(maquina.home.idHomeSeleccionDer)" (click)="redirigirAOEE(maquina.id, maquina.home.idHomeSeleccionDer)"
                    [ngClass]="[1,2,3].includes(maquina.home.idHomeSeleccionDer) ? 'home-oee': 'home-parametros'">
                  <div class="cont-home-donuts" *ngIf="maquina.home.idHomeSeleccionDer != 7 || (maquina.home.idHomeSeleccionDer == 7 && maquina.home.idEje1 != -1)">
                    <div *ngIf="!maquina.col1_datosCargados_2 && !loading" class="k-i-loading"></div>
                    <!-- donut 1 -->
                    <div class="cont-home-donut">
                      <!-- <div class="home-donut" id="{{'argia-col1_2_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col1_ensennarGrafico_2 && maquina.home.idHomeSeleccionDer == 7) || maquina.home.idHomeSeleccionDer != 7)}"></di -->
                        <div class="home-donut" id="{{'argia-col1_2_'+maquina.id}}"></div>  
                      <div class="valores-home-donut">
                        <label class="valor-home-donut">{{maquina.col1_value_2}}</label>
                        <label class="label-home-donut">{{maquina.col1_label_2}}</label>
                      </div>
                    </div>
                      
                    <!-- donut 2 -->
                    <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionDer != 7 || (maquina.home.idHomeSeleccionDer == 7 && maquina.home.idEje2 != -1)">
                      <!-- <div class="home-donut" id="{{'argia-col2_2_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col2_ensennarGrafico_2 && maquina.home.idHomeSeleccionDer == 7) || maquina.home.idHomeSeleccionDer != 7)}"></di -->
                        <div class="home-donut" id="{{'argia-col2_2_'+maquina.id}}"></div>  
                      <div class="valores-home-donut">
                        <label class="valor-home-donut">{{maquina.col2_value_2}}</label>
                        <label class="label-home-donut">{{maquina.col2_label_2}}</label>
                      </div>
                    </div>
                    
                    <!-- donut 3 -->
                    <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionDer != 7 || (maquina.home.idHomeSeleccionDer == 7 && maquina.home.idEje3 != -1)">
                      <!-- <div class="home-donut" id="{{'argia-col3_2_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col3_ensennarGrafico_2 && maquina.home.idHomeSeleccionDer == 7) || maquina.home.idHomeSeleccionDer != 7)}"></di -->
                        <div class="home-donut" id="{{'argia-col3_2_'+maquina.id}}"></div>  
                      <div class="valores-home-donut">
                        <label class="valor-home-donut">{{maquina.col3_value_2}}</label>
                        <label class="label-home-donut">{{maquina.col3_label_2}}</label>
                      </div>
                    </div>
                    
                    <!-- donut 4 -->
                    <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionDer != 7 || (maquina.home.idHomeSeleccionDer == 7 && maquina.home.idEje4 != -1)">
                      <!-- <div class="home-donut" id="{{'argia-col4_2_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col4_ensennarGrafico_2 && maquina.home.idHomeSeleccionDer == 7) || maquina.home.idHomeSeleccionDer != 7)}"></di -->
                        <div class="home-donut" id="{{'argia-col4_2_'+maquina.id}}"></div>  
                      <div class="valores-home-donut">
                        <label class="valor-home-donut">{{maquina.col4_value_2}}</label>
                        <label class="label-home-donut">{{maquina.col4_label_2}}</label>
                      </div>
                    </div> 
                  </div>
                </div>

                <div class="home-cuatro-graficos donuts-ilunak" *ngIf="[1,2,3,7].includes(maquina.home.idHomeSeleccionDer)" (click)="redirigirAOEE(maquina.id, maquina.home.idHomeSeleccionDer)"
                    [ngClass]="[1,2,3].includes(maquina.home.idHomeSeleccionDer) ? 'home-oee': 'home-parametros'">
                  <div class="cont-home-donuts" *ngIf="maquina.home.idHomeSeleccionDer != 7 || (maquina.home.idHomeSeleccionDer == 7 && maquina.home.idEje1 != -1)">
                    <div *ngIf="!maquina.col1_datosCargados_2 && !loading" class="k-i-loading"></div>
                    <!-- donut 1 -->
                    <div class="cont-home-donut">
                      <!-- <div class="home-donut" id="{{'iluna-col1_2_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col1_ensennarGrafico_2 && maquina.home.idHomeSeleccionDer == 7) || maquina.home.idHomeSeleccionDer != 7)}"></di -->
                        <div class="home-donut" id="{{'iluna-col1_2_'+maquina.id}}"></div>  
                      <div class="valores-home-donut">
                        <label class="valor-home-donut">{{maquina.col1_value_2}}</label>
                        <label class="label-home-donut">{{maquina.col1_label_2}}</label>
                      </div>
                    </div>
                      
                    <!-- donut 2 -->
                    <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionDer != 7 || (maquina.home.idHomeSeleccionDer == 7 && maquina.home.idEje2 != -1)">
                      <!-- <div class="home-donut" id="{{'iluna-col2_2_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col2_ensennarGrafico_2 && maquina.home.idHomeSeleccionDer == 7) || maquina.home.idHomeSeleccionDer != 7)}"></di -->
                        <div class="home-donut" id="{{'iluna-col2_2_'+maquina.id}}"></div>  
                      <div class="valores-home-donut">
                        <label class="valor-home-donut">{{maquina.col2_value_2}}</label>
                        <label class="label-home-donut">{{maquina.col2_label_2}}</label>
                      </div>
                    </div>
                    
                    <!-- donut 3 -->
                    <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionDer != 7 || (maquina.home.idHomeSeleccionDer == 7 && maquina.home.idEje3 != -1)">
                      <!-- <div class="home-donut" id="{{'iluna-col3_2_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col3_ensennarGrafico_2 && maquina.home.idHomeSeleccionDer == 7) || maquina.home.idHomeSeleccionDer != 7)}"></di -->
                        <div class="home-donut" id="{{'iluna-col3_2_'+maquina.id}}"></div>  
                      <div class="valores-home-donut">
                        <label class="valor-home-donut">{{maquina.col3_value_2}}</label>
                        <label class="label-home-donut">{{maquina.col3_label_2}}</label>
                      </div>
                    </div>
                    
                    <!-- donut 4 -->
                    <div class="cont-home-donut" *ngIf="maquina.home.idHomeSeleccionDer != 7 || (maquina.home.idHomeSeleccionDer == 7 && maquina.home.idEje4 != -1)">
                      <!-- <div class="home-donut" id="{{'iluna-col4_2_'+maquina.id}}" [ngClass]="{'invisible': !((maquina.col4_ensennarGrafico_2 && maquina.home.idHomeSeleccionDer == 7) || maquina.home.idHomeSeleccionDer != 7)}"></di -->
                        <div class="home-donut" id="{{'iluna-col4_2_'+maquina.id}}"></div>  
                      <div class="valores-home-donut">
                        <label class="valor-home-donut">{{maquina.col4_value_2}}</label>
                        <label class="label-home-donut">{{maquina.col4_label_2}}</label>
                      </div>
                    </div> 
                  </div>
                </div>

                <!-- Resumen -->
                <div class="home-resumen-semana" *ngIf="[4,5,6].includes(maquina.home.idHomeSeleccionDer)" (click)="redirigirRendimiento(maquina.id)">
                  <div *ngIf="!maquina.col1_datosCargados_2 && !loading" class="k-i-loading"></div>
                  <label>{{'resumensemana' | translate }}</label>
                  <div class="tooltip-consumibles-contenido">
                    <div class="graf-barr-part-cont "  id="barra1">
                      <div class="graf-barr-part-multi fondo-color-preparacion" id="barraTiemposPorcentajePreparacion" [style.width.%]="(maquina.TPorcentajePreparacion)">
                      </div>
                      <div class="graf-barr-part-multi fondo-color-ejecucion" id="barraTiemposPorcentajeEjecucion" [style.width.%]="(maquina.TPorcentajeEjecucion)" >
                      </div>
                      <div class="graf-barr-part-multi fondo-color-parada" id="barraTiemposPorcentajeParada" [style.width.%]="(maquina.TPorcentajeParada)" >
                      </div>
                      <div class="graf-barr-part-multi fondo-color-mantenimiento" id="barraTiemposPorcentajeMantenimiento" [style.width.%]="(maquina.TPorcentajeMantenimiento)">
                      </div>
                      <div class="graf-barr-part-multi fondo-color-alarma" id="barraTiemposPorcentajeAlarma" [style.width.%]="(maquina.TPorcentajeAlarma)">
                      </div>
                      <div class="graf-barr-part-multi fondo-color-apagada" id="barraTiemposPorcentajeApagado" [style.width.%]="(maquina.TPorcentajeApagado)">
                      </div>
                      <div class="graf-barr-part-multi fondo-color-microparada" id="barraTiemposPorcentajeMicroparada" [style.width.%]="(maquina.TPorcentajeMicroParada)">
                      </div>
                    </div>

                    <!-- tooltip -->
                    <span class="tooltiptextHome text-left"  >
                      <div class="tooltipDestacado info_preparacion" *ngIf="maquina.TPorcentajePreparacion > 0">
                      <label class="home-tooltip-titulo">{{ 'preparacion' | translate }}</label>
                      <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TPreparacion)}}</label>
                      <label class="home-tooltip-valor">{{maquina.TPorcentajePreparacion}}%</label>
                      </div>
                      
                      <div class="tooltipDestacado info_ejecucion" *ngIf="maquina.TPorcentajeEjecucion > 0">
                      <label class="home-tooltip-titulo">{{ 'ejecucion' | translate }}</label>
                      <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TEjecucion)}}</label>
                      <label class="home-tooltip-valor">{{maquina.TPorcentajeEjecucion}}%</label>
                      </div>
                      <div class="tooltipDestacado info_parada" *ngIf="maquina.TPorcentajeParada > 0">
                      <label class="home-tooltip-titulo">{{ 'parada' | translate }}</label>
                      <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TParada)}}</label>
                      <label class="home-tooltip-valor">{{maquina.TPorcentajeParada}}%</label>
                      </div>
                      <div class="tooltipDestacado info_mantenimiento" *ngIf="maquina.TPorcentajeMantenimiento > 0">
                      <label class="home-tooltip-titulo">{{ 'mantenimiento' | translate }}</label>
                      <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TMantenimiento)}}</label>
                      <label class="home-tooltip-valor">{{maquina.TPorcentajeMantenimiento}}%</label>
                      </div>
                      <div class="tooltipDestacado info_alarma" *ngIf="maquina.TPorcentajeAlarma > 0">
                      <label class="home-tooltip-titulo">{{ 'alarma' | translate }}</label>
                      <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TAlarma)}}</label>
                      <label class="home-tooltip-valor">{{maquina.TPorcentajeAlarma}}%</label>
                      </div>
                      <div class="tooltipDestacado info_apagada" *ngIf="maquina.TPorcentajeApagado > 0">
                      <label class="home-tooltip-titulo">{{ 'apagada' | translate }}</label>
                      <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TApagado)}}</label>
                      <label class="home-tooltip-valor">{{maquina.TPorcentajeApagado}}%</label>
                      </div>
                      <div class="tooltipDestacado info_microparada" *ngIf="maquina.TPorcentajeMicroParada > 0">
                      <label class="home-tooltip-titulo">{{ 'microparada' | translate }}</label>
                      <label class="home-tooltip-valor">{{this.myFunctions.secondsTo_HH_MM(maquina.TMicroParada)}}</label>
                      <label class="home-tooltip-valor">{{maquina.TPorcentajeMicroParada}}%</label>
                      </div>
                    </span>

                  </div>
                </div>
                <!-- Datos por hora -->
                <div class="home-euros-hora-cont" *ngIf="[8,9,10].includes(maquina.home.idHomeSeleccionDer)">
                    <div class="home-titulo-vertical">
                        <label title="{{ 'diaTotal' | translate }}">{{ 'diaTotal' | translate }}</label>
                    </div>
                    <!--€/h-->
                    <div class="home-euros-hora">
                        <label class="titulo" title="{{ 'eurosHoraAbrev' | translate }}">{{ 'eurosHoraAbrev' | translate }}</label>
                        <label class="home-valor-grande" title="{{ 'eurosHoraAbrev' | translate }}">{{ maquina.home.eurosHora }}</label>
                        <label class="diferencia" title="{{ 'eurosHoraAbrev' | translate }}" [ngClass]="!maquina.home.eurosHoraRojo ? 'home-label-verde': 'home-label-rojo'">{{ maquina.home.eurosHoraEstimado }}</label>
                    </div>
                    <!-- Circulo del porcentaje -->
                    <div class="home-circulo-porcentaje-hora-cont" [ngClass]="!maquina.home.porcentajeEurosHoraRojo ? 'home-fondo-verde': 'home-fondo-rojo'">
                        <div class="home-circulo-porcentaje">
                        <label class="home-label-porcentaje"> {{ maquina.home.porcentajeEurosHora }}% </label>
                        </div>
                    </div>
                    <!--Piezas/h-->
                    <div class="piezas-euros-hora">
                        <label class="titulo" title="{{ 'piezasHoraAbrev' | translate }}">{{ 'piezasHoraAbrev' | translate }}</label>
                        <label class="home-valor-grande" title="{{ 'piezasHoraAbrev' | translate }}">{{ maquina.home.piezasHora }}</label>
                        <label class="diferencia" title="{{ 'piezasHoraAbrev' | translate }}" [ngClass]="!maquina.home.piezasHoraRojo ? 'home-label-verde': 'home-label-rojo'">{{ maquina.home.piezasHoraEstimado }}</label>
                    </div>
                </div>
                <!-- Informacion turnos -->
                <div class="home-turno-contenedor" *ngIf="[11].includes(maquina.home.idHomeSeleccionDer)">
                  <div *ngIf="isNaN(maquina.home.datosOperaciones[0]?.tiempoActualTurno)" class="k-i-loading"></div>
                  <div class="home-actual-ritmo">
                      <!-- Turno -->
                      <div class="home-preparacion-pieza-lote">
                        <div class="home-titulo-vertical">
                          <div class="cont-label-icon">
                            <i class="icon-turnos"></i>
                            <label title="{{ 'pieza' | translate }}">{{ 'turno' | translate }}</label>
                          </div>

                          <div class="borde-fake borde-degradado-bottom"></div>
                        </div>
                        <div class="home-datos-actual">
                          <!-- real -->
                          <label *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion" class="home-tiempo-grande"> {{ timeDiff(maquina.home.datosOperaciones[0]?.tiempoActualTurno, maquina.home.datosOperaciones[0]?.horaServidorTiempos) }} </label>
                          <label *ngIf="(maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion)" class="home-tiempo-grande">NA</label>
                          <!-- cantidad de piezas -->
                          <div class="home-cantidad-turno">
                            <i class="icon-piezas-totales"></i>
                            <span *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion" class="home-cantidad-correcto">{{ maquina.home.datosOperaciones[0]?.cantidadTurno }}</span>
                            <span *ngIf="(maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion)" class="home-cantidad-correcto">0</span>

                            <span *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion">(<span class="home-cantidad-malas">{{ maquina.home.datosOperaciones[0]?.cantidadTurnoMal }}</span>)</span>
                            <span *ngIf="(maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion)">(<span  class="home-cantidad-malas">0</span>)</span>
                          </div>
                        </div>
                        <div class="home-datos-ritmo">
                          <!-- real -->
                          <label class="home-tiempo-grande" [ngClass]="maquina.home.datosOperaciones[0]?.tiempoTurnoRojo ? 'home-tiempo-superior': 'home-tiempo-inferior'" *ngIf="maquina.home.datosOperaciones[0]!=0 && maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion &&maquina.home.datosOperaciones[0]?.cantidadTurno!=0"> {{ myFunctions.secondsTo_HH_MM_SS(maquina.home.datosOperaciones[0]?.tiempoRitmoTurno) }} </label>
                          <label class="home-tiempo-grande" *ngIf="maquina.home.datosOperaciones[0]==0 || (maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion || maquina.home.datosOperaciones[0]?.cantidadTurno==0)"> NA </label>
                    
                          <!-- predictivo -->
                          <label *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion && maquina.home.datosOperaciones[0]?.cantidadTurno!=0" class="home-tiempo"> ({{myFunctions.secondsTo_HH_MM_SS(maquina.home.datosOperaciones[0]?.tiempoRitmoTurnoEstimado)}}) </label>
                          <label *ngIf="(maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion) || maquina.home.datosOperaciones[0]?.cantidadTurno==0" class="home-tiempo"> (NA) </label>
                          <div class="etiqueta" [ngClass]="{'home-fondo-verde': (!maquina.home.datosOperaciones[0]?.tiempoTurnoRojo && maquina.home.datosOperaciones[0]!=0), 'home-fondo-rojo': (maquina.home.datosOperaciones[0]?.tiempoTurnoRojo && maquina.home.datosOperaciones[0]!=0)}">
                          <!-- desvio -->
                          <label *ngIf="maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion && maquina.home.datosOperaciones[0]?.cantidadTurno!=0"> {{ myFunctions.secondsTo_HHh_MM(maquina.home.datosOperaciones[0]?.desvioTurno) }} </label>
                          <label *ngIf="(maquina.home.datosOperaciones.length==0 || maquina.home.sinConexion || maquina.home.datosOperaciones[0]?.cantidadTurno==0)"> {{ myFunctions.secondsTo_HHh_MM(0) }} </label>
                          <i class="icon-reloj"></i>
                          </div>
                        </div>
                      </div>
                      <!-- Circulo del porcentaje -->
                      <div class="home-circulo-porcentaje-cont" [ngClass]="{'home-fondo-verde': ((maquina.home.datosOperaciones[0]?.porcentajeTurno - 100) < 0 && maquina.home.datosOperaciones[0]!=0), 'home-fondo-rojo': ((maquina.home.datosOperaciones[0]?.porcentajeTurno - 100) > 0 && maquina.home.datosOperaciones[0]!=0)}">
                        <!-- aldatzeko -->
                        <div class="home-circulo-porcentaje">
                          <label class="home-label-porcentaje" *ngIf="maquina.home.datosOperaciones[0]!=0 && maquina.home.datosOperaciones.length!=0 && !maquina.home.sinConexion && maquina.home.datosOperaciones[0]?.cantidadTurno!=0"> {{(maquina.home.datosOperaciones[0]?.porcentajeTurno - 100).toFixed(1)}}% </label>
                          <label class="home-label-porcentaje" *ngIf="maquina.home.datosOperaciones[0]==0 || !(maquina.home.datosOperaciones.length!=0 || maquina.home.sinConexion) || maquina.home.datosOperaciones[0]?.cantidadTurno==0"> NA </label>
                        </div>
                      </div>
                    </div>
                </div>
                    
              </div>
            </div>
        </div>
      </div>
  </ng-container>

  <!-- INSTALACIONES -->
  <ng-container *ngFor="let instalacion of instalaciones; let i = index">

    <!-- Si tiene una columna -->
    <div class="form-horizontal panelosoa instalacion-estructura-1"
      *ngIf="instalacion.estructura != 2 && instalacion.idsGrupos.includes(appComponent.selectedGrupo.id) && instalacionesCargadas == true && !loading">
      <div class="inner-panel">

        <div class="clearfix">
          <!-- ROW 1 -->
          <a (click)="redirigirAProcesoInstalacion(instalacion.id)">
            <!-- Imagen de las instalaciones -->
            <div class="fotomaquina pqn">
              <img ID="fotomaquina" src="{{instalacion.imagenBase64}}" />
            </div>

            <!-- Nombre de la instalacion -->
            <label class="nombre-instalacion" title="{{instalacion.nombre}}">{{instalacion.nombre}}</label>

          </a>
        </div>

        <div class="clearfix datos-cols-cont">
          <div class="instalacion-nombre-cont" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT != 9"><label
              class="instalacion-nombre"> {{ instalacion['m1Inf']?.nombre }} </label></div>
          <div class="instalacion-nombre-cont"
            *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 9 && !showLabelResumenSemana"><label
              class="instalacion-nombre"> {{ instalacion['m1Inf']?.nombre }} </label></div>

          <!-- GRAFICOS -->
          <div *ngIf="[1, 10, 11, 12].includes(instalacion['m1Inf']?.id_tipoGrafico_DAT)"
            id="{{'graficoBarras_1_' + i}}"></div>
          <div *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 2" id="{{'graficoDonut_1_' + i}}"></div>
          <div *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 4" id="{{'graficoLineas_1_' + i}}"></div>
          <div class="grafico-presion" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 5"
            id="{{'graficoPresion_1_' + i}}"></div>

          <div class="cont-grafico-temperatura-label" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 6">

            <grafico-temperatura *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 6" id="{{'graficoTemperatura_1'}}"
              [min]="instalacion['m1Inf']?.min" [max]="instalacion['m1Inf']?.max" [value]="instalacion['m1Inf']?.value">
            </grafico-temperatura>

            <div class="cont-grafico-temperatura-info">
              <div class="grafico-temperatura-icono">
                <i class="icon-temperatura"></i>
              </div>
              <div class="grafico-temperatura-labels" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 6">

                <label> {{ instalacion['m1Inf']?.value }} </label>
                <label class="grafico-dato-unidad">{{ instalacion['m1Inf']?.unidad | translate }}</label>
              </div>
            </div>
          </div>

          <div class="cont-grafico-posicion-label" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 7">

            <div class="cont-grafico-posicion-info">
              <div class="grafico-posicion-icono">
                <i *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 7" class="icon-objetivo"></i>
              </div>
              <div class="grafico-posicion-labels">
                <label *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 7"> {{ instalacion['m1Inf']?.value }} </label>
                <label class="grafico-dato-unidad">{{ instalacion['m1Inf']?.unidad | translate }}</label>
              </div>
            </div>

            <grafico-posicion *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 7" id="{{'graficoPosicion_1'}}"
              [min]="instalacion['m1Inf']?.min" [max]="instalacion['m1Inf']?.max" [value]="instalacion['m1Inf']?.value"
              [minBarra]="instalacion['m1Inf']?.min" [maxBarra]="instalacion['m1Inf']?.max"> </grafico-posicion>
          </div>

          <div class="cont-grafico-nivel-label" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 3">
            <grafico-nivel *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 3" id="{{'graficoNivel_1'}}"
              [min]="instalacion['m1Inf']?.min" [max]="instalacion['m1Inf']?.max" [value]="instalacion['m1Inf']?.value">
            </grafico-nivel>

            <div class="cont-grafico-nivel-info">
              <div class="grafico-nivel-labels">
                <label class="grafico-nivel-label" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 3"> {{
                  instalacion['m1Inf']?.value }} </label>
                <label class="grafico-dato-unidad">{{ instalacion['m1Inf']?.unidad | translate }}</label>
              </div>
            </div>
          </div>

          <div class="cont-grafico-dato-label" *ngIf="[8, 13, 14, 15].includes(instalacion['m1Inf']?.id_tipoGrafico_DAT)">
            <div class="grafico-dato-icono">
              <i class="{{ instalacion['m1Inf']?.icono }}"></i>
            </div>
            <div class="grafico-dato-labels">
              <label>{{instalacion['m1Inf']?.value}}</label>
              <label class="grafico-dato-unidad">{{ instalacion['m1Inf']?.unidad | translate }}</label>
            </div>
          </div>

          <div *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 9 && !showLabelResumenSemana"
            id="{{'graficoResumenSemana_1_' + i}}"></div>
          <div *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 9"><span *ngIf="showLabelResumenSemana">{{
              'noDatosParaMostrar' | translate }}</span></div>

        </div>

      </div>
    </div>

    <!-- Si tiene dos columnas -->
    <div class="form-horizontal panelosoa instalacion-estructura-2"
      *ngIf="instalacion.estructura == 2 && instalacion.idsGrupos.includes(appComponent.selectedGrupo.id) && instalacionesCargadas == true && !loading">
      <div class="inner-panel">

        <div class="clearfix">
          <!-- ROW 1 -->
          <a (click)="redirigirAProcesoInstalacion(instalacion.id)">
            <div class="clearfix">
              <!-- Imagen de las maquinas-->
              <div ID="maquina" class="maquina">
                <div id="estado">
                  <div class="fotomaquina pqn">
                    <img ID="fotomaquina" src="{{instalacion.imagenBase64}}" />
                  </div>
                </div>
              </div>


              <div class="header-home-maquina clearfix">
                <!-- Nombre de la maquina -->
                <div class="modelo-operario-cont">
                  <div class="nombre-modelo-maquina">
                    <div class="modelo-maquina">
                      <label ID="lmodelo" title="{{instalacion.nombre}}">{{instalacion.nombre}}</label>
                    </div>
                  </div>

                </div>


              </div>
            </div>
          </a>
        </div>

        <!-- GRAFICOS -->
        <div class="clearfix datos-cols-cont">

          <!-- 1 -->
          <div class="datos-of-col">
            <div class="instalacion-nombre-cont" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT != 9"><label
                class="instalacion-nombre"> {{ instalacion['m1Inf']?.nombre }} </label></div>
            <div class="instalacion-nombre-cont"
              *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 9 && !showLabelResumenSemana"><label
                class="instalacion-nombre"> {{ instalacion['m1Inf']?.nombre }} </label></div>

            <div *ngIf="[1, 10, 11, 12].includes(instalacion['m1Inf']?.id_tipoGrafico_DAT)"
              id="{{'graficoBarras_1_' + i}}"></div>
            <div *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 2" id="{{'graficoDonut_1_' + i}}"></div>
            <div *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 4" id="{{'graficoLineas_1_' + i}}"></div>
            <div class="grafico-presion" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 5"
              id="{{'graficoPresion_1_' + i}}"></div>

            <div class="cont-grafico-temperatura-label" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 6">

              <grafico-temperatura *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 6" id="{{'graficoTemperatura_1'}}"
                [min]="instalacion['m1Inf']?.min" [max]="instalacion['m1Inf']?.max"
                [value]="instalacion['m1Inf']?.value"> </grafico-temperatura>

              <div class="cont-grafico-temperatura-info">
                <div class="grafico-temperatura-icono">
                  <i class="icon-temperatura"></i>
                </div>
                <div class="grafico-temperatura-labels" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 6">

                  <label> {{ instalacion['m1Inf']?.value }} </label>
                  <label class="grafico-dato-unidad">{{ instalacion['m1Inf']?.unidad | translate }}</label>
                </div>
              </div>
            </div>

            <div class="cont-grafico-posicion-label" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 7">

              <div class="cont-grafico-posicion-info">
                <div class="grafico-posicion-icono">
                  <i *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 7" class="icon-objetivo"></i>
                </div>
                <div class="grafico-posicion-labels">
                  <label *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 7"> {{ instalacion['m1Inf']?.value }}
                  </label>
                  <label class="grafico-dato-unidad">{{ instalacion['m1Inf']?.unidad | translate }}</label>
                </div>
              </div>

              <grafico-posicion *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 7" id="{{'graficoPosicion_1'}}"
                [min]="instalacion['m1Inf']?.min" [max]="instalacion['m1Inf']?.max"
                [value]="instalacion['m1Inf']?.value" [minBarra]="instalacion['m1Inf']?.min"
                [maxBarra]="instalacion['m1Inf']?.max"> </grafico-posicion>
            </div>

            <div class="cont-grafico-nivel-label" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 3">
              <grafico-nivel *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 3" id="{{'graficoNivel_1'}}"
                [min]="instalacion['m1Inf']?.min" [max]="instalacion['m1Inf']?.max"
                [value]="instalacion['m1Inf']?.value"> </grafico-nivel>

              <div class="cont-grafico-nivel-info">
                <div class="grafico-nivel-labels">
                  <label class="grafico-nivel-label" *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 3"> {{
                    instalacion['m1Inf']?.value }} </label>
                  <label class="grafico-dato-unidad">{{ instalacion['m1Inf']?.unidad | translate }}</label>
                </div>
              </div>
            </div>

            <div class="cont-grafico-dato-label" *ngIf="[8, 13, 14, 15].includes(instalacion['m1Inf']?.id_tipoGrafico_DAT)">
              <div class="grafico-dato-icono">
                <i class="{{ instalacion['m1Inf']?.icono }}"></i>
              </div>
              <div class="grafico-dato-labels">
                <label>{{instalacion['m1Inf']?.value}}</label>
                <label class="grafico-dato-unidad">{{ instalacion['m1Inf']?.unidad | translate }}</label>
              </div>
            </div>

            <div *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 9 && !showLabelResumenSemana"
              id="{{'graficoResumenSemana_1'}}"></div>
            <div *ngIf="instalacion['m1Inf']?.id_tipoGrafico_DAT == 9"><span *ngIf="showLabelResumenSemana">{{
                'noDatosParaMostrar' | translate }}</span></div>



          </div>
          <!-- 2 -->
          <div class="datos-of-col">
            <div class="instalacion-nombre-cont" *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT != 9"><label
                class="instalacion-nombre"> {{ instalacion['m2Inf']?.nombre }} </label></div>
            <div class="instalacion-nombre-cont"
              *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 9 && !showLabelResumenSemana"><label
                class="instalacion-nombre"> {{ instalacion['m2Inf']?.nombre }} </label></div>

            <div *ngIf="[1, 10, 11, 12].includes(instalacion['m2Inf']?.id_tipoGrafico_DAT)"
              id="{{'graficoBarras_2_' + i}}"></div>
            <div *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 2" id="{{'graficoDonut_2_' + i}}"></div>
            <div *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 4" id="{{'graficoLineas_2_' + i}}"></div>
            <div class="grafico-presion" *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 5"
              id="{{'graficoPresion_2_' + i}}"></div>

            <div class="cont-grafico-temperatura-label" *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 6">

              <grafico-temperatura *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 6" id="{{'graficoTemperatura_1'}}"
                [min]="instalacion['m1Inf']?.min" [max]="instalacion['m1Inf']?.max"
                [value]="instalacion['m2Inf']?.value"> </grafico-temperatura>

              <div class="cont-grafico-temperatura-info">
                <div class="grafico-temperatura-icono">
                  <i class="icon-temperatura"></i>
                </div>
                <div class="grafico-temperatura-labels" *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 6">

                  <label> {{ instalacion['m2Inf']?.value }} </label>
                  <label class="grafico-dato-unidad">{{ instalacion['m2Inf']?.unidad | translate }}</label>
                </div>
              </div>
            </div>

            <div class="cont-grafico-posicion-label" *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 7">

              <div class="cont-grafico-posicion-info">
                <div class="grafico-posicion-icono">
                  <i *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 7" class="icon-objetivo"></i>
                </div>
                <div class="grafico-posicion-labels">
                  <label *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 7"> {{ instalacion['m2Inf']?.value }}
                  </label>
                  <label class="grafico-dato-unidad">{{ instalacion['m2Inf']?.unidad | translate }}</label>
                </div>
              </div>

              <grafico-posicion *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 7" id="{{'graficoPosicion_1'}}"
                [min]="instalacion['m2Inf']?.min" [max]="instalacion['m2Inf']?.max"
                [value]="instalacion['m2Inf']?.value" [minBarra]="instalacion['m2Inf']?.min"
                [maxBarra]="instalacion['m2Inf']?.max"> </grafico-posicion>
            </div>

            <div class="cont-grafico-nivel-label" *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 3">
              <grafico-nivel *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 3" id="{{'graficoNivel_1'}}"
                [min]="instalacion['m1Inf']?.min" [max]="instalacion['m1Inf']?.max"
                [value]="instalacion['m2Inf']?.value"> </grafico-nivel>

              <div class="cont-grafico-nivel-info">
                <div class="grafico-nivel-labels">
                  <label class="grafico-nivel-label" *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 3"> {{
                    instalacion['m2Inf']?.value }} </label>
                  <label class="grafico-dato-unidad">{{ instalacion['m2Inf']?.unidad | translate }}</label>
                </div>
              </div>
            </div>

            <div class="cont-grafico-dato-label" *ngIf="[8, 13, 14, 15].includes(instalacion['m2Inf']?.id_tipoGrafico_DAT)">
              <div class="grafico-dato-icono">
                <i class="{{ instalacion['m2Inf']?.icono }}"></i>
              </div>
              <div class="grafico-dato-labels">
                <label>{{instalacion['m2Inf']?.value}}</label>
                <label class="grafico-dato-unidad">{{ instalacion['m2Inf']?.unidad | translate }}</label>
              </div>
            </div>

            <div *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 9 && !showLabelResumenSemana"
              id="{{'graficoResumenSemana_2'}}"></div>
            <div *ngIf="instalacion['m2Inf']?.id_tipoGrafico_DAT == 9"><span *ngIf="showLabelResumenSemana">{{
                'noDatosParaMostrar' | translate }}</span></div>

          </div>
        </div>

      </div>
    </div>

  </ng-container>
</div>
